import { render, staticRenderFns } from "./AdBanner.vue?vue&type=template&id=8c49e5aa&"
import script from "./AdBanner.vue?vue&type=script&lang=js&"
export * from "./AdBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports